import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {APP_CONFIG} from '../../misc/inject-tokens';
import {AppConfig} from '../../model/app-config.model';

@Injectable({providedIn: 'root'})
export class SupportDevToolService {
  private readonly http = inject(HttpClient);
  private readonly config = inject<AppConfig>(APP_CONFIG);

  refreshOfferIndex(offerId: number): Observable<void> {
    return this.http.put<void>(this.config.salesApiUrl + '/support/offer/refresh-index/' + offerId, null);
  }

  refreshVehicleIndex(vehicleId: number): Observable<void> {
    return this.http.put<void>(this.config.salesApiUrl + '/support/vehicle/refresh-index', [vehicleId]);
  }
}
